import { PopoverAlignment, PopoverPosition } from './popover.types';

export const DEFAULT_POPOVER_POSITION: PopoverPosition = 'top';
export const DEFAULT_POPOVER_ALIGNMENT: PopoverAlignment = 'center';
